module.exports = __webpack_public_path__ + "static/group-2-16435059ed51b2d335f0ad7a2a6374f1.png";